/***
 * @Author: ZhaoG
 * @Date: 2025-06-05 14:54:21
 * @LastEditors: ZhaoG
 * @LastEditTime: 2025-06-05 14:58:00
 * @FilePath: \gcp-fe\src\config\i18n\locale\zh-CN.js
 * @Description:
 */
export default {
  locale: "zh-CN",
  language: "简体中文",
  menu: {
    i18n: "多语言"
  },
  page: {
    content: {
      announcementStatus: "公告状态",
      purchaseStatus: "采购类型",
      material: "物资",
      equipment: "设备",
      service: "服务",
      Bidevaluationresults: "评标结果",
      Bidnotification: "中标通知",
      SupplementaryAnnouncement: "补遗公告",
      Flowlabelannouncement: "流标公告",
      BusinessAnnouncement: "业务公告",
      Publiclyannounced: "公示中",
      Ended: "已结束",
      status: "状态", //状态
      pleaseSelectStatus: "请选择状态查询", //请选择状态查询
      MoreAndMore: "更多",
      loginTip: "您尚未登录 请先登录",
      passValid: "确认密码和新密码应保持一致！",
      passValid1: "旧密码和新密码不能重复！",
      blockNoData: "暂无更多公告",
      supplierPortal: "首页",
      projectCode: "项目编号",
      publishTime: "发布时间",
      deadlineEndTime: "申请截止时间", //申请截止时间
      xunjiajiezhiTime: "询价截止时间", //询价截止时间
      ApplicationTime: "报名截止时间", // 报名截止时间
      labelMenu1: "评标结果",
      labelMenu2: "流标公告",
      labelMenu3: "补遗公告",
      labelMenu4: "邀请公告",
      labelMenu5: "中标通知",
      labelMenu6: "招标采购",
      labelMenu7: "询价采购",
      labelMenu8: "竞争谈判",
      labelMenu9: "邀请竞价",
      labelMenu10: "公开询价",
      labelMenu11: "公开竞价",
      labelMenu12: "公开拍卖", // 公开拍卖
      projectNamePlaceholder: "请输入项目名称",
      search: "搜索",
      allClassify: "全部分类",
      menu1: "首页",
      menu2: "集中采购",
      menu3: "区域联采",
      menu4: "供应商注册",
      menu5: "供应链金融",
      menu6: "业务协同",
      menu7: "站内信",
      menu8: "供应商信息变更",
      menu9: "合作意向申请",
      menu10: "联系我们",
      menu11: "云租APP",
      Hello: "您好",
      welcomeToBack: "Hi,欢迎回来",
      denglu: "登录",
      zhuce: "注册",
      loginText: "登录供应商门户",
      Exit: "退出",
      improveInfo: "完善信息",
      changeInfo: "修改信息",
      viewReasons: "查看原因",
      withdrawApplication: "撤回注册申请",
      supplierLogin: "供应商登录",
      pleaseLogin: "请登录",
      Announcements: "通知公告",
      purchase: "采购",
      inviteNotice: "邀请公告",
      noticeName: "公告名称",
      xunjiaName: "询价名称",
      wasteNotice: "废旧物资处置公告", // 废旧物资处置公告
      lianhecaigou: "联合采购专区公告", // 废旧物资处置公告
      haiwaicaigou: "海外采购专区公告", // 海外采购专区公告
      category: "类别", // 类别
      invitationType: "邀请招标协议类", // 协议类邀请
      agreementType: "公开招标协议类", //协议类公开
      projectName: "项目名称",
      searchPlaceholder: "搜索 项目公告",
      packageNum: "包件数量",
      fromEndTime: "距离结束",
      viewDetail: "查看详情",
      downLoad: "下载",
      to: "至",
      startTime: "开始时间",
      endTime: "结束时间",
      joinStatus: "参与状态",
      title: "公告名称",
      titlePlaceholder: "请输入标题模糊查询",
      serialNo: "序号",
      publishUnit: "发布单位",
      signUpEndTime: "报名结束剩余时间",
      day: "天",
      hour: "时",
      minute: "分",
      second: "秒",
      immediatelySignUp: "立即报名（仅供应商可报名）",
      immediatelySignUpFB: "立即报名（仅分包商可报名）",
      participated: "已参与",
      toMyProject: "进入项目",
      notice: "公告",
      noticeTitle: "公告标题",
      noticeDetail: "见公告详情",
      noticeContent: "公告内容",
      contractInfo: "联系信息",
      fileList: "附件列表",
      supplierBiddingProcess: "供应商投标操作流程",
      pleaseClickView: "请点击查看",
      materialInfos: "采购清单",
      quantitiesInfo: "工程量清单",
      packageDesc: "包件说明",
      materialInfo: "物资信息",
      relatedNoticeList: "相关公告列表",
      purchaseMoney: "采购金额",
      thousandYuan: "万元",
      camulativePurchaseItems: "累计招标项目",
      inquiryProjectNum: "询价项目数量",
      biddingProjectNum: "竞谈项目数量",
      unitStillPurchase: "该单位还在采购",
      fileName: "附件名称",
      fileDesc: "附件说明",
      fileSize: "附件大小",
      fileTime: "上传时间", // 上传时间
      upload: "下载",
      operation: "操作",
      equipmentName: "设备物资名称",
      transMatName: "运输设备物资名称",
      equipmentDesc: "设备物资说明",
      code: "编码",
      name: "名称",
      quantities: "工程量",
      featRemark: "项目特征描述",
      remark: "备注",
      types: "类型",
      num: "数量",
      tax: "税率",
      unit: "单位",
      type: "公告类型",
      link: "环节",
      other: "其他",
      aboutUs: "关于我们",
      introPlatform: "平台简介",
      contactUs: "联系我们",
      contactUsPostcode: "邮编",
      contactUsPhone: "电话",
      contactUsConsultTime: "咨询时间",
      exceptStatutoryHolidays: "法定节假日除外", // 法定节假日除外
      relevantPoliciesAndRegulations: "相关政策与规范",
      purchaser: "采购方",
      operationGuide: "操作指引",
      videoTutorial: "视频教程",
      supplier: "供应商",
      Partners: "合作商",
      supplierName: "供应商名称",
      netInformation: "入网须知",
      commonProblem: "常见问题",
      purchaseCommonProblem: "采购方常见问题",
      supplierCommonProblem: "供应商常见问题",
      PartnersCommonProblem: "合作商常见问题",
      serviceCenter: "服务中心",
      onlineCounsel: "在线咨询",
      afterSalesService: "售后服务",
      feedback: "意见反馈",
      fileTemplateDownload: "文件模板下载",
      supplyChainFinanceCenter: "供应链金融中心",
      officialWeChat: "官方微信",
      navigation: "栏目导航",
      source: "来源",
      add: "新增",
      author: "作者",
      publishDate: "发布日期",
      all: "全部",
      prev: "< 上一页",
      next: "下一页 >",
      To: "到第", //到第
      page: "页", //页
      article: "条", //条
      total: "共", //共
      eachPage: "每页", //每页
      sure: "确定",
      noRelatedData: "暂无相关数据",
      supplierOperationManual: "供应商操作手册",
      operationManual: "操作手册",
      supplierOperationGuide: "供应商操作指南",
      noData: "暂无数据",
      question: "业务流程及常见问题",
      purchaseType: "采购方式",
      xunjiaType: "询价方式",
      materialClassify: "物资分类",
      multiSelect: "多选",
      yewuSource: "业务来源",
      cancel: "取消",
      onlySupplierLogin: "仅供应商登录可选",
      publicBidding: "公开招标",
      publicInquiry: "公开询价",
      publicOutcry: "公开竞价",
      otherProcurement: "其他采购",
      openSingleSource: "公开单一来源",
      openOfflineBidding: "线下公开招标",
      offlinePublicInquiry: "线下公开询价",
      openCollaboration: "公开合作谈判",
      wasteMaterials: "废旧物资处置",
      publicAuction: "公开拍卖",
      inquiry: "邀请询价",
      inviteBidd: "邀请竞价",
      competitiveProcurement: "竞价采购",
      competitiveNegotiation: "邀请竞争性谈判",
      invitationTender: "邀请招标",
      nearly3Days: "近3天",
      nearly7Days: "近一周",
      nearly30Days: "近一个月",
      invite: "邀请",
      open: "公开",
      yicanyu: "已参与",
      pleaseEnterTheTitle: "请输入标题", //请输入标题
      // category: "类别", //类别
      totalResult: "全部结果", //全部结果
      openCompetitiveNegotiations: "公开性竞争谈判", //公开性竞争谈判
      openCompetitiveNegotiation: "公开竞争性谈判", //公开竞争性谈判
      procurementAnnouncement: "采购公告", //采购公告
      laowucaiLink: "供应商门户（旧版）",
      laowucaiLinkMsg:
        "注：点击此处可跳转老版供应商门户，完成进行中的招投标操作。",
      invitationAnnouncement: "邀请公告", //邀请公告
      applicationDeadline: "报名截止时间", //报名截止时间
      serviceAnnouncement: "业务公告", //业务公告
      mallPurchaseAnnouncement: "商城式订单采购公告",
      resourceSharing: "资源共享", //资源共享
      qualityService: "优质服务", //优质服务
      legalCompliance: "合法合规", //合法合规
      reduceCostsAndincrease: "降本增效", //降本增效
      managementPromotion: "管理提升", //管理提高
      businessCoordinationToBeDone: "业务协同待办", //业务协同待办
      // officialWechat: "官方微信", //官方微信
      pleaseSelectStatusTip: "请选择状态查询", //请选择状态查询
      pleaseSelectPurchaseTypeTip: "请选择采购方式查询",
      agreementTypeOpenBidding: "(协议类)公开招标", //(协议类)公开招标
      invitationToTenderagreement: "(协议类)邀请招标", //(协议类)邀请招标
      inThePublicity: "公示中", //公示中
      alreadyEnded: "已结束", //已结束
      preview: "预览", //预览
      Copyright1: "Copyright©2022中交电商All rights reserved.", //Copyright © 2018 中交电商 All rights reserved.
      divider: "最终解释权：", //最终解释权
      statement1: "闽ICP备2022005227号-2 中交电商", //闽ICP备2022005227号-2 中交电商
      onlineService: "在线客服",
      contactUsPostcodeFull: "邮编：100088",
      supplierOperationPhone: "供应商运营服务联系电话：400-903–0036",
      subcontractorSupplyChainPhone: "分包商/供应链联系电话：400-676–5885",
      winningBidServiceFeePhone: "中标服务费联系电话：400-676–5885 转7",
      consultTimeFull: "咨询时间：8:30-11:30  13:30-17:30(法定节假日除外)",
      supplierContactEmail: "供应商联系E-mail：cpo@ccccltd.cn",
      contactUsAddress: "联系地址：北京市西城区德胜门外大街85号",
      engineeringServiceInProgress: "工程服务(建设中)",
      openProcurementAnnouncement: "公开采购公告",
      biddingResultPublicity: "中标结果公示",
      underConstruction: "建设中",
      viewMoreProcurementAnnouncement: "查看更多采购公告 >",
      seeNoticeDetails: "见公告详情",
      engineeringSubcontracting: "工程分包",
      otherServices: "其它服务",
      hourFull: "小时",
      noticeTypeLabel: "公告类型",
      onlyLoginRequired: "仅登录可选",
      inquiryCompareShort: "询比",
      invitationInquiryCompare: "邀请询比",
      publicInquiryCompare: "公开询比",
      negotiationShort: "谈判",
      invitationNegotiation: "邀请谈判",
      publicNegotiation: "公开谈判",
      auctionShort: "竞价",
      directProcurement: "直接采购",
      publicDirectProcurement: "公开直接采购",
      otherPathPublicBidding: "其他途径公开招标",
      procurementCategory: "采购分类",
      subcontractingTypeLabel: "分包类型",
      provinceCity: "省市",
      procurementOrg: "采购组织",
      isOverseasPurchase: "是否海外采购",
      yesValue: "是",
      noValue: "否",
      collapse: "收起",
      expand: "展开",
      advancedSearchCollapse: "高级搜索 收起▲",
      advancedSearchExpand: "高级搜索 展开▼",
      purchaseNo: "采购编号",
      invitationProcurementAnnouncement: "邀请采购公告",
      bidReviewResultPublicity: "评标/评审结果公示",
      bidNotification: "中标通知",
      supplementaryAnnouncement: "补遗公告",
      flowAnnouncement: "流标公告",
      businessAnnouncement: "业务公告",
      otherProcurementAlt: "其它采购",
      offlinePublicBidding: "线下公开招标",
      signingUp: "报名中",
      landConstructionEquipment: "陆上施工设备",
      waterConstructionEquipment: "水上施工设备",
      otherEquipment: "其他设备",
      portNavigation: "港航",
      dredging: "疏浚",
      highway: "公路",
      bridge: "桥梁",
      tunnel: "隧道",
      railTransit: "轨道交通",
      airport: "机场",
      mechanicalElectrical: "机电",
      waterConservancyHydropower: "水利水电",
      ecologicalEnvironment: "生态环保",
      greenEnergy: "绿色能源",
      otherBusiness: "其他业务",
      municipalUtilities: "市政共用",
      greenIntegration: "绿色融合",
      housing: "房建",
      steel: "钢材",
      cementProducts: "水泥及其制品",
      asphaltProducts: "沥青及其制品",
      fuelLubricants: "燃润料",
      otherMetalMaterials: "其他金属材料",
      woodBambooProducts: "木材及其竹木制品",
      chemicalStandardElectrical: "化轻、标准件及电工产品",
      buildingDecorativeMaterials: "建筑装饰材料",
      specialToolsEquipment: "专用材料及工器具",
      assetServiceCategory: "资产及服务类",
      otherTypes: "其他类型",
      housingConstruction: "房建业务",
      municipalPublicUtilities: "市政公用"
    },
    sup: {
      title: "供应商操作指南",
      content1: "中国交建电子采购平台 —— 供应商门户",
      content2:
        "是供应商加入中国交通建设集团有限公司（以下简称“中国交建”）供应商网络的唯一合法的电子商务网站。中国交建按照“互利共赢、诚信合作”的原则，与供应商建立积极的合作关系。",
      content3:
        "中国交建对供应商实行准入管理，经准入的供应商具备参与中国交建及所属企业的线上投标和报价资格。凡有意参与中国交建采购业务的供应商均须认真阅读入网须知及注册指南，选择",
      content4: "注册（推荐单位为供应商信息的初审单位），经审核通过后入网。",
      content5: "请为保证系统的稳定兼容性，请使用",
      content6:
        "或以上版本的IE浏览器（同时选择兼容模式），以获得最佳效果。设置方法参见：",
      contentStrong: "推荐单位",
      questions: "常见问题解答",
      explain: "其他说明如下：",
      explain1: "1. 供应商入网须知",
      explain2: "2. 注册流程",
      explain3: "3. 常见问题解答",
      explain4: "2. 操作手册",
      explain5: "5. 如何找回密码",
      explain6: "6. 供应商在线投标重要提示及操作流程",
      supNetInformation: "供应商入网须知",
      netInformation1:
        "1. 中国交通建设集团有限公司设备物资采购管理信息平台是供应商加入中国交通建设集团有限公司（以下简称“中国交建”）供应商网络的唯一合法网站。中国交建按照“互利共赢、诚信合作”的原则，与供应商建立积极的合作关系。",
      netInformation2:
        "2. 中国交通建设集团有限公司对申请入网的供应商不收取任何费用，不颁发相关证书，也不以年审、会员制、业绩考核等名义向供应商收取费用。供应商填写入网信息必须真实、准确并及时更新。",
      netInformation3:
        "3.如遇系统升级，平台运营方有权延长招标结束时间、售标结束时间。",
      faqName: "供应商在线投标重要提示及操作流程",
      createUserName: "中国交通建设集团有限公司",
      releaseMechanism: "发布机构：",
      releaseTime: "发布时间：",
      titleContent: "为保障招标活动的顺利进行，请投标供应商认真阅读以下内容：",

      titleContent1:
        "一、避开投标高峰时间：高峰时间（8:00—18:00），特别是投标截止日前一天。",
      titleContent2:
        "二、控制投标文件大小：投标文件应控制在30M以内，为避免提交标书时上传速度慢，影响文件的递交，请尽量压缩投标文件和图片尺寸。",
      titleContent3:
        "三、投标操作：建议供应商避开高峰时间投标，可采用分步上传技术投标文件和商务报价函（先上传技术投标文件）的方法。",
      titleContent4: "四、具体演示：",
      operationProcess: "供应商投标操作流程",
      clickOnTitleToView: "点击标题查看",

      table: {
        title: "附件列表",
        serialNumber: "序号",
        fileName: "附件名称",
        fileSize: "附件大小",
        fileDesc: "附件说明",
        fileTime: "上传时间", // 上传时间
        operation: "操作"
      },
      dialog: {
        title: "关于供应商在线投标的重要提示",
        dialogTitle: "为保障招标活动的顺利进行，请投标供应商认真阅读以下内容：",
        content1: "一、避开投标高峰时间",
        contentP1: "高峰时间（每日6:00—18:00），特别是投标截止日前一天。",
        content2: "二、控制投标文件大小",
        contentP2:
          "投标文件应控制在30M以内，为避免提交标书时上传速度慢，影响文件的递交，请尽量压缩投标文件。",
        content3: "三、投标操作",
        contentP3:
          "建议供应商避开高峰时间投标，可采用分步上传技术投标文件和商务报价函（先上传技术投标文件）的方法。投标操作具体演示如下：",
        participateInBidd: "1.参与招标",
        participateInBiddCont1:
          "1)使用IE浏览器登陆供应商门户网站（https://sp.iccec.cn）",
        participateInBiddCont2:
          "2)登陆后点击邀请公告。点击一条公告进入后，网页下方有一个参与按钮，点击进入填写联系信息并提交。此时系统会提示您已“报名成功”。",
        biddingDocuments: "2.下载招标文件",
        biddingDocumentsCont1:
          "1)招标人收到标书费用，会通过系统给供应商发送招标文件，您在待办提醒里可以看到采购文件下载",
        biddingDocumentsCont2:
          "2)待办提醒还可以提供答疑、投标、补遗、澄清等信息。",
        tender: "3.投标",
        tenderCont1: "1)投标阶段开始后请查看待办提醒，点击。",
        tenderCont2:
          "2)供应商也可以点击供应商门户地址栏下方的业务协同，进入您的工作界面。",
        tenderCont3:
          "3)进入工作界面后，页面左侧有您参与的方案，点击方案后进入投标菜单进行投标。",
        tenderCont4:
          "4）为避免附件大造成投标失败，建议在投标结束前一天完成网上投标。",
        tenderCont5:
          "您也可以分步上传标书文件，首先填写报价表，并上传技术投标文件，点击提交按钮；此时系统提示",
        aTender: "投标成功",
        tenderCont6: "在商务报价表做好后，在投标菜单点击",
        tenderCont7:
          "按钮，修改报价，通过“上传”按钮把商务报价文件上传至系统后，点击提交完成最终报价。",
        tenderCont8: "备注：请不要点击撤销投标，点击后系统会删除所有投标文件。",
        reportAgain: "再次上报",
        toClarify: "4.澄清",
        toClarifyCont:
          "在评标阶段，招标方会通过系统发布澄清文件，请在待办提醒中查看并回复。",
        question: " 5.质疑",
        questionCont:
          "供应商如对招标文件有疑问，可通过点击首页的业务协同，在业务协同页面左侧找到参与的项目，点击参与的项目找到质疑答疑菜单，上传您的质疑文件，也可查看招标方答疑文件。",
        addendumFile: "6.查看补遗文件",
        addendumFileCont:
          "如果招标方发布补遗文件，您可以在首页的待办提醒里查看。",
        notes: "四、电子标书大小注意事项",
        notesCont1:
          "在制作投标文件的过程中，因投标书含有许多图片导致文件很大而影响上传。为避免提交标书时上传速度慢，请尽量压缩投标文件和图片尺寸，文件大小应控制在30M以内。也可以将Word文件转换为PDF格式并使用压缩包软件，压缩文件大小。",
        notesCont2: "1.转换为PDF格式有2种方法：",
        notesCont3:
          "1) 一种是在Word中直接另存为PDF格式，并压缩尺寸（含Office2007, 2010和2013版本）。",
        notesCont4:
          "2) 一种是安装PDF虚拟打印机，自动生成PDF文档。（Office2003不带PDF转换，就需要安装此软件，PDFCreator软件为开源软件，任何人都可以免费安装使用）。下载地址",
        click: "点击",
        notesCont5: "2.以下为Office 2007及以上版本直接另存为PDF格式的方法：",
        notesCont6:
          "1) 以Office2010为例，在Word文档中选择文件另存为，保存类型选择",
        notesCont7: "2) 在优化项选择“针对以下格式优化",
        notesCont8: "可将文件压缩至20M以内。",
        smallestFileSize: "最小文件大小",
        sure: "确定",
        cancel: "取消",
        spread: "展开",
        shrinkage: "收缩"
      }
    },
    login: {
      title: "供应商登录",
      pwLogin: "密码登录",
      smsLogin: "短信登录",
      pleaseUn: "用户名/手机号",
      pleasePw: "请输入密码",
      loginName: "登录",
      smsSendSuccessTip1: "短信验证码已发送至",
      smsSendSuccessTip2: "请注意查收",
      telNo: "手机号",
      smsVerCode: "短信验证码",
      sendVerCode: "发送验证码",
      sended: "已发送",
      jjt: "交建通",
      wx: "微信",
      Copyright: "Copyright © 2018 中国交建 All rights reserved.",
      statement: "最终解释权：闽ICP备2022005227号-2 中国交建",
      acApiErrorObj: {
        error1: "该登录账号因无效登录超过6次已被锁定30分钟",
        error2: "未实名",
        error3: "登录账号已被冻结",
        error4: "系统服务暂不可用，请稍后重试"
      },
      pwApiErrorObj: {
        error1: "登录账号与登录密码不匹配，请重新输入",
        error2: "请滑动完成验证"
      },
      telErrorObj: {
        error1: "请输入正确的手机号",
        error2: "手机号与短信密码不匹配，请重新输入。",
        error3: "手机号短信验证码无效登录6次，将锁定手机号30分钟",
        error4: "系统服务暂不可用,请稍后重试"
      },
      smsSliderErrorObj: {
        error1: "请滑动完成验证"
      },
      smsErrorObj: {
        error1: "请勿重复发送，倒计时完成后可再次获取验证码",
        error2: "发送验证码失败,请稍后再试"
      },
      upLang: {
        _startTEXT: "请按住滑块，拖动到最右侧",
        _yesTEXT: "验证通过",
        _noTEXT: "验证不通过",
        _error300:
          '哎呀，出错了，点击<a href="javascript:__nc.reset()">刷新</a>再来一次',
        _errorNetwork:
          '网络不给力，请<a href="javascript:__nc.reset()">点击刷新</a>'
      }
    },
    retrievePassword: {
      retrievePassword: "取回密码",
      changePassword: "修改密码", //修改密码
      oldPassword: "旧密码：", // 旧密码
      pleaseOldPassword: "请输入旧密码", // 请输入旧密码
      newPassword: "新密码：", // 新密码
      pleaseNewPassword: "请输入新密码", // 请输入新密码
      verifyNewPassword: "Please enter the correct password", // 请输入正确的密码
      confirmPassword: "确认密码：", // 确认密码
      pleaseConfirmPassword: "请确认密码", // 请确认密码
      contactUs: "联系我们", // 联系我们
      title: "在线取回用户名密码",
      content1: "首先下载并填写",
      content2: "《供应商用户名及密码找回申请表》",
      downLoad: "点击下载",
      content3:
        "，需加盖单位公章并扫描，然后把申请表扫描件和营业执照扫描件上传到系统。提交用户及密码找回申请，申请由管理员审批通过后，系统自动把申请找回的用户名及随机密码发送至您填写的邮箱，根据邮件信息登录系统重置随机密码。",
      content4:
        "（注：可以输入新的手机号和联系人信息进行取回）提交申请后，工作日当天处理，结果发送到接收邮箱，如遇节假日顺延。", // （注：可以输入新的手机号和联系人信息进行取回）
      supName: "供应商名称：",
      holderSupName: "请输入供应商名称",
      hintContent1: "供应商用户名，密码取回联系人及联系方式：",
      hintContent2:
        "（注：申请人信息须与申请表中申请人信息一致，该申请人不一定是注册联系人。）",
      contactName: "申请人姓名：",
      contactPerson: "联系人：", // 联系人
      mobilePhone: "手机号：", // 手机号
      holderContactPerson: "请输入联系人姓名", // 请输入联系人姓名
      holderMobilePhone: "请输入联系人手机", // 请输入联系人手机
      holderContactName: "请输入申请人姓名",
      contactMobile: "申请人手机：",
      holderContactMobile: "请输入申请人手机",
      effectiveMobile: "请输入有效的手机号码",
      hintContent3: "接收用户名及密码的真实有效邮箱：",
      hintContent4:
        "（注：请填写真实有效的邮箱，申请信息审批通过后，会把用户名及随机密码发送至该邮箱。该邮箱不一定是注册联系人邮箱。）",
      hintContent5: "联系人信息必须与扫描件保持一致", //联系人信息必须与扫描件保持一致
      hintContent6: "8-16位大小写字母，特殊字符和数字的组合", //6-8位大小写字母，特殊字符和数字的组合
      hintContent7: "长度在6到8个字符", // 长度在6到8个字符
      email: "E-mail地址：",
      verificationCode: "验证码：", // 验证码
      holderEmail: "请输入E-mail地址",
      effectiveEmail: "请输入正确的邮箱地址",
      holderVerificationCode: "请输入验证码", // 请输入验证码
      effectiveVerificationCode: "请输入正确的验证码", // 请输入正确的验证码
      fileinfoTypeName: "名称",
      fileinfoType1: "供应商用户名及密码找回申请表扫描件",
      fileinfoType2: "供应商营业执照扫描件",
      fileType: "类型",
      fileTypeName: "图片",
      fileName: "文件",
      operation: "操作",
      upload: "上传",
      delete: "删除",
      downloadSampleTable: "样表下载",
      submit: "提交",
      reset: "重置",
      confirmTitle1: "您的供应商密码取回申请提交成功，请注意查收邮件或短信",

      confirmHint: "提示",
      ascertain: "确定",
      confirmTitle2: "请您上传附件后提交申请！",
      fileSuccess: "附件上传成功",
      uploadError: "上传出错，请联系管理员",
      confirmTitle3: "供应商名称的输入有误！请输入，该项不能为空或空格",
      confirmTitle4: "供应商名称不存在，请输入正确的供应商名称！",
      confirmTitle5: "请完善信息后上传附件！",
      confirmTitle6: "密码修改成功，请您重新登录!",
      confirmTitle7: "撤回成功!",
      confirmTitle8: "您的注册申请尚未完成，请点击完善信息按钮完成申请 ！", // 申请尚未完成，请点击完善信息按钮完成申请！
      confirmTitle9:
        "您注册申请审批退回 ，可点击按钮查看退回原因或修改注册信息",
      fileSizeNO50: "文件大小不可超过50M！",
      uploadBmpError: "上传文件格式错误！",
      NoSameName: "请不要上传重名文件！"
    }
  },
  shopHead: {
    selectPlc: "请选择",
    options: {
      labelOne: "采购公告",
      searchPlcOne: "搜索 采购公告",
      labelTwo: "采购公示",
      searchPlcTwo: "搜索 采购公示",
      labelThree: "供应链商品金融",
      searchPlcThree: "安全帽"
    },
    searchBtn: "搜索",
    dataPlaceholder: "请输入公告名称/项目编号，开始找标讯",
    brandList: {
      menuOne: "首页",
      menuTwo: "采购公告",
      menuThree: "工程分包",
      menuFour: "云采商城",
      menuFive: "资源共享",
      menuSix: "物流运输",
      menuSeven: "智慧云仓",
      menuEight: "供应链金融",
      menuNine: "车辆专区"
    }
  },
  showDataPage: {
    dataOptions: {
      titleOne: "合作商数量(家)", // 合作商数量(家)
      remarkOne: "汇聚优质合作商，招投标更高效", // 汇聚优质合作商，招投标更高效
      titleTwo: "采购笔数", // 采购笔数
      remarkTwo: "采购项目丰富，机会无限", // 采购项目丰富，机会无限
      titleThree: "中标通知", // 中标通知
      remarkThree: "招采项目抢先看，提升中标率", // 招采项目抢先看，提升中标率
      titleFour: "今日新增采购公告", // 今日新增采购公告
      remarkFour: "海量采购公告，等你来竞标" // 海量采购公告，等你来竞标
    }
  },
  shopMenu: {
    brandList: {
      menuOne: "首页", // 首页
      menuTwo: "采购公告", // 采购公告
      menuThree: "电子投标", // 电子投标
      menuFour: "电子商城", // 电子商城
      menuFive: "专区入口", // 专区入口
      menuFive1: "海外专区", // 海外专区
      menuFive2: "RH专区", // RH专区
      menuFive3: "资源共享", // 资源共享
      menuFive4: "物流运输", // 物流运输
      menuFive5: "智慧云仓", // 智慧云仓
      menuFive6: "机电与零配件专区", // 机电与零配件专区
      menuFive7: "车辆专区", // 车辆专区
      menuSix: "增值服务", // 增值服务
      menuSix1: "CA认证", // CA认证
      menuSix2: "光速标讯", // 光速标讯
      // menuSeven: "供应链金融", // 供应链金融
      menuSeven: "智信平台", // 智信平台
      menuEight: "信用评价与反馈" // 信用评价与反馈
    }
  },
  showUser: {
    title: "您好", // 您好
    welcomeTitle: "欢迎来到中交招采网", // 欢迎来到中交招采网
    logout: "退出登录", // 退出登录
    login: "登录", // 登录
    register: "注册", // 注册
    findPassword: "供应商找回密码", // 供应商找回密码
    findPasswordSub: "分包商找回密码", // 分包商找回密码
    controlListOrBlackAppeal: "管控名单或黑名单申诉" // 管控名单或黑名单申诉
  },
  // 政策法规 通知公告
  noticeList: {
    noticeTitle: "政策法规",
    noticeTitleItem: "法规",
    noticeTitle1: "通知公告",
    noticeTitleItem1: "公告",
    more: "更多",
    newDynamicsList: {
      label: "最新通知公告",
      labelMore: "查看更多采购公告",
      labelAll: "全  部",
      labelItem1: "物  资",
      labelItem2: "设  备",
      labelItem3: "工程分包",
      labelItem4: "工程服务",
      labelItem5: "其它服务",
      labelItem6: "工程服务(建设中)"
    },
    nodeList: {
      label: "查看公告详情",
      labelItem: "报名剩余时间",
      labelItem2: "发布时间",
      noData: "暂无数据"
    }
  },
  // 专区入口
  zoneEntrance: {
    title: "专区入口", // 专区入口
    imgData: {
      label: "海外专区", // 海外专区
      RH: "RH专区", // RH专区
      resource: "资源共享", // 资源共享
      logistics: "物流运输", // 物流运输
      warehouse: "智慧云仓", // 智慧云仓
      machine: "机电与零配件专区", // 机电与零配件专区
      vehicle: "车辆专区", // 车辆专区
      descriptionOne: "跨境联通，海外业务新篇章", // 跨境联通，海外业务新篇章
      descriptionTwo: "融智创效", // 融智创效
      descriptionThree: "周转材料 机具设备 在线下单 一键租赁", // 周转材料 机具设备 在线下单 一键租赁
      descriptionFour: "整合运力资源 汇集物流需求", // 整合运力资源 汇集物流需求
      descriptionFive: "提供安全、高效、便捷、专业的数字化仓储服务", // 提供安全、高效、便捷、专业的数字化仓储服务
      descriptionSix: "机电精选，选配无忧", // 机电精选，选配无忧
      descriptionSeven: "轻松租车，畅行无忧", // 轻松租车，畅行无忧
      btnText: "立即查看" // 立即查看
    }
  },
  // 增值服务
  valueAddedService: {
    title: "增值服务", // 增值服务
    linkList: {
      labelOne: "操作指引", // 操作指引
      labelTwo: "CA认证", // CA认证
      labelThree: "光速标讯", // 光速标讯
      labelFour: "供应链金融" // 供应链金融
    }
  },
  // 底部导航
  pageFooter: {
    officialWechat: "官方微信", // 官方微信
    company: "中交(厦门)电子商务有限公司", // 中交(厦门)电子商务有限公司
    finalInter: "最终解释权", // 最终解释权
    officialEcommerce: "中交电商", // 中交电商
    serviceItemData: {
      resource: "资源共享", // 资源共享
      service: "优质服务", // 优质服务
      legalCompliance: "合法合规", // 合法合规
      costReduction: "降本增效", // 降本增效
      managementImprovement: "管理提升" // 管理提升
    },
    helpData: {
      aboutUs: "关于我们", // 关于我们
      platformIntroduction: "平台简介", // 平台简介
      contactUs: "联系我们", // 联系我们
      purchase: "采购方", // 采购方
      operationGuidelines: "操作指引", // 操作指引
      cooperation: "合作商", // 合作商
      entryRequirements: "入网须知", // 入网须知
      commonQuestions: "常见问题", // 常见问题
      purchaseCommonQuestions: "采购方常见问题", // 采购方常见问题
      cooperationCommonQuestions: "合作商常见问题", // 合作商常见问题
      serviceCenter: "服务中心", // 服务中心
      onlineConsultation: "在线咨询", // 在线咨询
      feedback: "意见反馈" // 意见反馈
    }
  },
  // 管控名单或黑名单申诉
  subAppeal: {
    title: "管控名单或黑名单申诉", // 管控名单或黑名单申诉
    appealType: "申请类型：", // 申请类型
    appealTypePlaceholder: "请选择申请类型", // 请选择申请类型
    appeal: "申诉", // 申诉
    creditRepair: "信用修复", // 信用修复
    subconName: "申请单位名称：", // 申请单位名称
    subconNamePlaceholder: "请输入申请单位名称", // 请输入申请单位名称
    repairType: "修复类型：", // 修复类型
    repairTypePlaceholder: "请选择修复类型", // 请选择修复类型
    controlList: "管控名单", // 管控名单
    blackList: "黑名单", // 黑名单
    controlRange: "管控范围：", // 管控范围
    controlRangePlaceholder: "请选择管控范围", // 请选择管控范围
    controlRangeCode: "限制范围：", // 限制范围
    controlRangeCodePlaceholder: "请选择限制范围", // 请选择限制范围
    documentNumber: "单据编号：", // 单据编号
    documentNumberPlaceholder: "请输入单据编号", // 请输入单据编号
    appealReason: "申请理由：", // 申请理由
    appealReasonPlaceholder: "请输入申请理由", // 请输入申请理由
    phoneNumber: "手机号码：", // 手机号码
    phoneNumberPlaceholder: "请输入手机号码", // 请输入手机号码
    second: "秒后", // 秒后
    sendCode: "发送验证码", // 发送验证码
    verificationCode: "验证码：", // 验证码
    verificationCodePlaceholder: "请输入验证码", // 请输入验证码
    attachmentUpload: "附件上传：", // 附件上传
    attachmentUploadPlaceholder: "只能上传doc/docx/pdf文件，且不超过50M", // 只能上传上传doc/docx/pdf文件，且不超过50M文件
    clickUpload: "点击上传", // 点击上传
    delete: "删除", // 删除
    submit: "提 交", // 提交
    reset: "重 置", // 重置
    phoneNumberEmpty: "手机号不能为空", // 手机号不能为空
    phoneNumberFormat: "请输入正确的手机号", // 请输入正确的手机号
    emailPlaceholder: "请输入邮箱地址", // 请输入邮箱地址
    emailFormat: "请输入正确的邮箱地址", // 请输入正确的邮箱地址
    emailEmpty: "邮箱不能为空", // 邮箱不能为空
    subconNameEmpty: "请先填写申请单位名称", // 请先填写申请单位名称
    singleUpload: "单次只能上传一个附件", // 单次只能上传一个附件
    fileSizeLimit: "文件大小不超过50M!", // 文件大小不超过50M文件
    fileSizeLimitEmpty: "文件大小不可为0B!", // 文件 文件大小不可为0B!
    uploadFileFormatError: "上传文件格式错误！", // 上传文件格式错误！
    uploadLoading: "上传中...", // 上传中...
    uploadSuccess: "上传成功!", //  上传成功!
    uploadError: "上传至服务器失败请重新上传", // 上传至服务器失败请重新上传！
    uploadEmpty: "请上传附件", // 请上传附件！
    confirm: "请确认信息填写是否正确？", // 请确认信息填写是否正确？
    submitSuccess: "提交成功！", // 提交成功！
    validatePhoneNumber: {
      title: "拼图验证",
      title1: "换一张",
      title2: "拼图加载中...", // 拼图加载中
      title3: "向右滑动完成拼图",
      title4: "发送验证码"
    }
  },
  // 分包商找回密码
  subFindPassword: {
    title: "分包商找回密码", // 分包商找回密码
    subconName: "单位全称：", // 单位全称：
    subconNamePlaceholder: "请输入单位全称", // 请输入单位全称
    isOverseas: "是否境外：", // 是否境外
    isOverseasPlaceholder: "请选择是否境外", // 请选择是否境外
    email: "邮箱：", // 邮箱：
    emailPlaceholder: "请输入邮箱", // 请输入邮箱
    type: "类型：", // 类型：
    typePlaceholder: "请选择类型", // 请选择类型
    subcontractor: "分包商", // 分包商
    supplier: "供应商", // 供应商
    merchant: "商家", // 商家
    purchaseUnit: "采购单位", // 采购单位
    phoneNumber: "手机号码：", // 手机号码：
    phoneNumberPlaceholder: "请输入手机号码", // 请输入手机号码
    attachmentTemplate: "附件模板：", // 附件模板：
    findPasswordTemplate: "交建云商密码找回模板", // 交建云商密码找回模板
    clickDownload: "点击此处下载", // 点击此处下载
    attachmentTemplatePlaceholder: "请上传附件模板", // 附件模板（按照模板填写之后上传）
    confirmPhoneNumber:
      "请再次确认手机号码，审批通过后手机号码会绑定为当前填写号码", // 请再次确认手机号码，审批通过后手机号码会绑定为当前填写号码
    submitSuccess: "您已提交成功，一个工作日内处理！", // 您已提交成功，一个工作日内处理！
    yes: "是",
    no: "否"
  }
};
